import { render, staticRenderFns } from "./formEvents.vue?vue&type=template&id=cc0a3d18&scoped=true"
import script from "./formEvents.vue?vue&type=script&lang=js"
export * from "./formEvents.vue?vue&type=script&lang=js"
import style0 from "./formEvents.vue?vue&type=style&index=0&id=cc0a3d18&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0a3d18",
  null
  
)

export default component.exports